module.exports = __webpack_public_path__ + "static/media/Pittogramma-candidatura.07722e33.png";